import type { KNUser } from 'context/authentication/UserContext.types'
import i18n from 'i18n'

interface UserPropertiesProps {
  label: string
  value: string
}

export const getUserPropertiesWithValues = (user: KNUser): UserPropertiesProps[] => {
  return [
    { label: i18n.t('screens.shared.profile.account_id'), value: user.uid },
    { label: i18n.t('screens.shared.profile.email'), value: user.email },
    { label: i18n.t('screens.shared.profile.role'), value: user.type },
  ]
}
